import { FC, MouseEventHandler } from "react";

export interface SignInGovBrButtonProps {
  onClick?: (() => void) | MouseEventHandler<HTMLButtonElement>;
}

export const SignInGovBrButton: FC<SignInGovBrButtonProps> = ({ onClick }) => (
  <button className="br-sign-in primary" type="button" onClick={onClick}>
    <span>Entrar com&nbsp;</span>
    <span className="text-black">
      <strong>gov.br</strong>
    </span>
  </button>
);
